import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { Icon } from 'fireflink-ui';
import cx from 'classnames';
import style from '@pages/common/Inputs/inputs.module.scss';
import { Tooltip } from '@material-ui/core';

const ColumnDropdown = ({ onSelect, columns, focusState, showIcon }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuKey, setMenuKey] = useState(0);
  const iconRef = useRef(null);
  const open = Boolean(anchorEl);

  const openMenu = () => {
    setAnchorEl(null);
    setTimeout(() => {
      setAnchorEl(iconRef.current);
      setMenuKey((prev) => prev + 1);
    }, 0);
  };

  const handleClick = () => {
    if (open) {
      openMenu();
    } else {
      setAnchorEl(iconRef.current);
    }
  };

  const handleKeyDown = useCallback((e) => {
    if (e.altKey && e.key.toLowerCase() === 'a') {
      e.preventDefault();
      openMenu();
    }
  }, []);

  useEffect(() => {
    if (focusState) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [focusState, handleKeyDown]);

  const handleClose = (value) => {
    if (value) {
      onSelect({ value, key: Date.now() });
    }
    setAnchorEl(null);
  };

  return (
    <div className={style.dropdown}>
      {showIcon && (
        <div className="autofill-icon" ref={iconRef}>
          <Icon name="auto_fill_steps_icon" height={24} width={24} className="" hoverFill onClick={handleClick} />
        </div>
      )}

      <Menu
        key={menuKey}
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose(null)}
        MenuListProps={{ className: cx(style['select-box-menu-list-wrapper']) }}
        slotProps={{
          paper: {
            sx: {
              marginLeft: '-16px',
              marginTop: '-20px',
            },
          },
        }}
      >
        <div className={style.placeholderRow}>
          <Tooltip title="Select Column for step to reproduce" placement="bottom">
            <div>
              <MenuItem disabled sx={{ fontWeight: 500, opacity: 0.6 }} className={style.placeholderItem}>
                <span className={style.placeholder}>Select Column for step to reproduce</span>
              </MenuItem>
            </div>
          </Tooltip>
          <div className={style.dropdownIconWrapper}>
            <Icon
              name="auto_fill_steps_icon"
              color="#FFFFFF"
              height={26}
              width={26}
              onClick={() => handleClose(null)}
            />
          </div>
        </div>

        {columns?.map((col, index) => (
          <Tooltip title={col} placement="bottom" key={index}>
            <MenuItem onClick={() => handleClose(col)} className={`${style.menuItem} ${style.selected}`}>
              <span className={style.menuItemText}>{col}</span>
            </MenuItem>
          </Tooltip>
        ))}
      </Menu>
    </div>
  );
};

export default ColumnDropdown;
